<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { onMount } from 'svelte';
	import type { Post } from '$lib/api/rpc';
	import { NodeViewWrapper } from 'svelte-tiptap';
	import type { NodeViewProps } from '@tiptap/core';
	import DragAndDropWrapper from '$lib/components/TextEditor/Components/DragAndDropWrapper/DragAndDropWrapper.svelte';
	import { page } from '$app/stores';
	import { getQuickPollURL } from '$lib/utils/getQuickPollURL';

	export let node: NodeViewProps['node'];
	export let deleteNode: () => void;
	export let updateAttributes: NodeViewProps['updateAttributes'];

	if (!$page.data.respHub || !$page.data.respSessionHubUser)
		throw new Error('TextEditor QuickPoll: Missing hub or user');

	const hub = $page.data.respHub.hub;
	const user = $page.data.respSessionHubUser.user;

	let url: string;
	let post: Post | null;

	const makePost = () => {
		const newPost = {
			type: 'widget',
			etc: {
				widget: {
					url,
				},
			},
		};
		updateAttributes({ post: newPost });
	};

	const handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Enter') {
			url = url.trim();
			if (url.length > 0 && url.match(/^(http|https):\/\//)) {
				makePost();
			} else if (url.length > 0 && url.includes('.')) {
				url = `https://${url}`;
				makePost();
			}
		}
	};

	onMount(() => {
		post = node.attrs.post;
		url = post?.etc?.widget?.url ?? '';
	});

	const deleteNodeWrapper = () => {
		deleteNode();
	};

	// A normal autofocus leads to some strange race conditions and do not work if we insert more than one link
	const focus = (node: HTMLInputElement) => {
		setTimeout(() => node.focus());
	};
</script>

<NodeViewWrapper id="svelte-component">
	<DragAndDropWrapper on:delete={deleteNodeWrapper}>
		{#if !node.attrs.post?.etc?.widget?.url}
			<div class="link">
				<input
					use:focus
					bind:value={url}
					type="text"
					placeholder={$_('hub.settings.widget.quickPoll.url')} />
			</div>
			{#if url != ''}
				<span class="linkEnter">{$_('composer.press.enter.to.submit')}</span>
			{/if}
		{:else}
			<div>
				<iframe src={getQuickPollURL({ hub, user, quickPollUrl: url })} title="QuickPoll" />
			</div>
		{/if}
	</DragAndDropWrapper>
</NodeViewWrapper>

<svelte:window on:keydown={handleKeydown} />

<style>
	.link {
		block-size: auto;
		inline-size: 100%;
		padding: var(--gutterSmallest);
		border: 1.5px solid #408ce9;
		border-radius: 2px;
	}

	.link > input {
		block-size: auto;
		inline-size: 100%;
		padding: var(--gutterSmall);
		border: 1px solid var(--grayLight);
		border-radius: 2px;
		outline: none;
	}

	.linkEnter {
		color: var(--grayMedium);
	}

	iframe {
		block-size: 543px;
		inline-size: 100%;
		border: none;
	}
</style>
